import React from 'react';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import DownloadIcon from '@mui/icons-material/Download';
import { formatFileSize } from '../utils/helpers';
import Loader from '../shared/Loader';

const styles = {
  documentAttachment: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    borderColor: 'rgba(0, 0, 0, 0.1)',
    padding: '10px',
    borderRadius: '10px',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    alignSelf: 'flex-start',
    cursor: 'pointer'
  },
  documentAttachmentDisabled: {
    cursor: 'default'
  },
  documentDetails: {
    flex: 1,
    marginLeft: '8px',
    marginRight: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minWidth: 0
  },
  documentFileName: {
    fontSize: '14px',
    fontWeight: '500',
    marginBottom: '2px',
    lineHeight: '18px',
    color: '#000',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
  },
  documentFileSize: {
    fontSize: '11px',
    lineHeight: '14px',
    color: '#666',
    whiteSpace: 'nowrap'
  }
};

const ChatDocumentContent = ({ style, fileName, fileSize, onPress, loading }) => {
  return (
    <div
      style={{
        ...styles.documentAttachment,
        ...style,
        ...(onPress ? {} : styles.documentAttachmentDisabled)
      }}
      onClick={(event) => {
        event.stopPropagation();
        onPress();
      }}
    >
      <InsertDriveFileIcon sx={{ fontSize: 24, color: '#090909', flexShrink: 0 }} />

      <div style={styles.documentDetails}>
        <div style={styles.documentFileName}>{fileName || 'Attachment'}</div>

        {fileSize ? <div style={styles.documentFileSize}>{formatFileSize(fileSize)}</div> : null}
      </div>

      {loading ? (
        <Loader />
      ) : (
        <DownloadIcon sx={{ fontSize: 20, color: '#707070', flexShrink: 0 }} />
      )}
    </div>
  );
};

export { ChatDocumentContent };
